module.exports = __webpack_public_path__ + "img/banner-t2.9b599a53.png";